<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .warnings {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    gap: utils.in_rem(8px);

    .warning-icon {
      @include colors.color(textWhite);
      font-size: utils.in_rem(12.8px);
      position: relative;
      cursor: pointer;

      .exclamation {
        color: colors.get(systemWarning_100);
        font-size: utils.in_rem(12.8px);
        margin-right: utils.in_rem(-5px);
        margin-top: utils.in_rem(-5px);
        position: absolute;
        right: 0;
        top: 0;
      }

      .tooltip {
        position: absolute;
        top: 100%;
        right: 0%;
        background: colors.get(interfaceTransparentBlack_30);
        color: colors.get(textWhite);
        padding: utils.in_rem(8px) utils.in_rem(12px);
        border-radius: utils.in_rem(4px);
        font-size: utils.in_rem(12px);
        white-space: nowrap;
        opacity: 0;
        visibility: hidden;
        transition:
          opacity 0.2s ease,
          visibility 0.2s ease;
        z-index: 1000;
        margin-top: utils.in_rem(8px);

        &::after {
          content: "";
          position: absolute;
          bottom: 100%;
          right: 2.5%;
          border: utils.in_rem(4px) solid transparent;
          border-bottom-color: colors.get(interfaceTransparentBlack_30);
        }
      }

      &:hover .tooltip {
        opacity: 1;
        visibility: visible;
      }
    }
  }
</style>

<script>
  import { diallerState } from "../diallerState.svelte";
  const networkWarning = $derived(diallerState.networkWarning);
  const audioWarning = $derived(diallerState.audioWarning);
</script>

<div class="warnings">
  {#if networkWarning}
    <div class="warning-icon">
      <i class="fa-solid fa-wifi"></i>
      <i class="exclamation fa-solid fa-circle-exclamation"></i>
      <div class="tooltip">{networkWarning}</div>
    </div>
  {/if}
  {#if audioWarning}
    <div class="warning-icon">
      <i class="fa-solid fa-microphone-slash"></i>
      <i class="exclamation fa-solid fa-circle-exclamation"></i>
      <div class="tooltip">{audioWarning}</div>
    </div>
  {/if}
</div>
